<template>
  <BoardView v-if="isLoaded" class="AdminUserSummary" title="Vartotojo santrauka">
    <h3 class="sectionLabel">
      Vartotojas
    </h3>
    <section>
      <CardUser :user="user" />
    </section>
    <h3 class="sectionLabel">
      Rezervacijos
    </h3>
    <section>
      <CardReservation v-for="reservation in reservations" :key="reservation.id" :reservation="reservation" />
    </section>
  </BoardView>
</template>

<script>
import { actions, getters } from 'views/utils'
import BoardView from 'components/board/BoardView'
import CardReservation from './components/admin/CardReservation'
import CardUser from './components/admin/CardUser'

export default {
  components: { BoardView, CardReservation, CardUser },
  computed: {
    user() {
      return this.query('user', this.$route.params.id)
    },
    reservations() {
      return this.query('reservation', {
        userId: this.user.id,
        $sort: {
          createdAt: 1,
        },
      })
    },
    ...getters(),
  },
  methods: actions(
    'FETCH_RESERVATION',
    'LOAD_RESERVATIONS_CHILDREN',
    'LOAD_STEP_TREE',
    'FETCH_APVA_STAGE',
  ),
  async mounted() {
    await this.LOAD(() => Promise.all([
      this.LOAD_STEP_TREE(),
      this.FETCH_RESERVATION({ userId: this.$route.params.id }),
      this.FETCH_APVA_STAGE(),
    ]))

    await this.LOAD_RESERVATIONS_CHILDREN(this.reservations)
  },
}
</script>

<style lang="scss">
.AdminUserSummary {
  .sectionLabel {
    font-size: $h25;
    margin: 2rem 0 1rem;
  }
}
</style>
